import en from './locales/en.json';
import tr from './locales/tr.json';

export const LANGUAGE_RESOURCES = {
  en: { translation: en, label: 'English', nativeLabel: 'English', flag: 'EN' },
  tr: { translation: tr, label: 'Turkish', nativeLabel: 'Türkçe', flag: 'TR' },
};

export const SUPPORTED_LANGUAGES = Object.keys(LANGUAGE_RESOURCES);

export function getLanguageMeta(code) {
  return LANGUAGE_RESOURCES[code] || LANGUAGE_RESOURCES.en;
}

export function isSupportedLanguage(code) {
  return SUPPORTED_LANGUAGES.includes(code);
}
